/* global API_ROOT */
import { createSelector } from 'reselect'
import { isMobileSelector } from 'reduxModules/app/selectors'
import { authInfoSelector, tokenSelector } from 'reduxModules/auth/selectors'

export const certificatesSelector = (state) => state.certificates.list
export const certificatesStatusSelector = (state) => state.certificates.status

// Download anchors must NOT point at the pre-signed CloudFront URL the API
// returns with the certificate: GTM's GA cross-domain linker decorates anchor
// clicks to *.stanwinstonschool.com with `_gl=…`, which invalidates the
// signature (AccessDenied), and the signed URL expires while the page stays
// open. The API download endpoint 302s to a fresh signed URL on every click;
// `?jwt=` carries auth because a plain navigation sends no Authorization
// header (same pattern as the video playlist URLs).
export const certificateDownloadUrl = (id, token) =>
  `${API_ROOT}/certificates/${id}/download/?jwt=${encodeURIComponent(token)}`

// Same rule for the All-Courses certificate (SPEC-040 D6).
export const generalCertificateDownloadUrl = (token) =>
  `${API_ROOT}/certificates/general/download/?jwt=${encodeURIComponent(token)}`

export const generalCertificateSelector = (state) => state.certificates.general

export const certificatesReselector = createSelector(
  [
    certificatesSelector,
    certificatesStatusSelector,
    authInfoSelector,
    isMobileSelector,
    tokenSelector,
    generalCertificateSelector
  ],
  (certificates, status, authInfo, isMobile, token, general) => ({
    certificates,
    status,
    isMobile,
    token,
    general,
    // Every row is a completed course (claimed or not), so one row is enough
    // to offer the All-Courses certificate
    hasCompletions: Boolean(certificates && certificates.length),
    // Prefill for the claim form (FR-3): account name when present
    defaultName: [authInfo.firstName, authInfo.lastName]
      .filter(Boolean)
      .join(' ')
  })
)
